interface DropboxIconProps {
    className?: string
}

export function DropboxIcon({ className = 'w-4 h-4' }: DropboxIconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 2l6 3.75L6 9.5 0 5.75zM18 2l6 3.75-6 3.75-6-3.75zM0 13.25L6 9.5l6 3.75L6 17zM18 9.5l6 3.75L18 17l-6-3.75zM6 18.25l6-3.75 6 3.75-6 3.75z" fill="#0061FF" />
        </svg>
    )
}
